(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drop-destacado"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('drop-destacado')) {
  customElements.define('drop-destacado', class DropDestacado extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.dotsEl = this.querySelector('[data-dots]');
      this.modals = [...this.querySelectorAll('[data-modal]')];
      this.modals.forEach((m) => { document.body.appendChild(m); this.setupModal(m); });
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.scrollByCard(-1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.scrollByCard(1));
      this.track?.addEventListener('scroll', () => this.updateDots(), { passive: true });
      window.addEventListener('resize', this.onResize = () => this.buildDots());
      this.buildDots();

      this.cardVideos = [...this.querySelectorAll('[data-card-video]')];
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          const v = en.target;
          if (en.isIntersecting) {
            if (!v.getAttribute('src')) v.src = v.dataset.src;
            v.play().catch(() => {});
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.35 });
      this.cardVideos.forEach((v) => {
        v.addEventListener('playing', () => v.classList.add('is-playing'));
        this.io.observe(v);
      });

      this.addEventListener('click', (e) => {
        const quick = e.target.closest('[data-quick-add]');
        if (quick && quick.dataset.single === 'true') {
          e.stopPropagation();
          const fd = new FormData();
          fd.append('id', quick.dataset.variantId);
          fd.append('quantity', 1);
          quick.classList.add('is-loading');
          this.addToCart(fd).catch(() => {}).finally(() => quick.classList.remove('is-loading'));
          return;
        }
        const opener = e.target.closest('[data-open]');
        if (opener) this.openModal(opener.dataset.open);
      });

      this.escHandler = (e) => { if (e.key === 'Escape') this.closeModal(); };
      document.addEventListener('keydown', this.escHandler);
    }

    disconnectedCallback() {
      this.modals.forEach((m) => m.remove());
      if (this.io) this.io.disconnect();
      document.removeEventListener('keydown', this.escHandler);
      window.removeEventListener('resize', this.onResize);
      document.body.classList.remove('dd-modal-open');
    }

    cardWidth() {
      const c = this.track.querySelector('[data-card]');
      return c ? c.getBoundingClientRect().width + 16 : 300;
    }
    scrollByCard(dir) {
      const perView = Math.max(1, Math.round(this.track.clientWidth / this.cardWidth()));
      this.track.scrollBy({ left: dir * this.cardWidth() * perView, behavior: 'smooth' });
    }
    buildDots() {
      if (!this.track || !this.dotsEl) return;
      const pages = Math.max(1, Math.ceil(this.track.scrollWidth / this.track.clientWidth - 0.05));
      this.dotsEl.innerHTML = '<i></i>'.repeat(pages);
      this.dotsEl.style.display = pages > 1 ? 'flex' : 'none';
      this.updateDots();
    }
    updateDots() {
      const dots = this.dotsEl.querySelectorAll('i');
      if (!dots.length) return;
      const max = this.track.scrollWidth - this.track.clientWidth;
      const idx = max <= 0 ? 0 : Math.round((this.track.scrollLeft / max) * (dots.length - 1));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    }

    openModal(id) {
      const m = this.modals.find((x) => x.dataset.modal === id);
      if (!m) return;
      this.closeModal();
      m.hidden = false;
      document.body.classList.add('dd-modal-open');
      this.activeModal = m;
      const v = m.querySelector('[data-video]');
      if (v) {
        if (!v.querySelector('source') && !v.getAttribute('src')) v.src = v.dataset.src;
        v.currentTime = 0;
        v.play().catch(() => {});
      }
      m.querySelector('[data-close]:not(.dd-modal__overlay)')?.focus();
    }
    closeModal() {
      const m = this.activeModal;
      if (!m) return;
      m.hidden = true;
      m.querySelector('[data-video]')?.pause();
      m.classList.remove('dd-modal--expanded');
      document.body.classList.remove('dd-modal-open');
      this.activeModal = null;
    }

    setupModal(m) {
      m.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', () => this.closeModal()));

      const v = m.querySelector('[data-video]');
      if (v) {
        const fmt = (s) => `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, '0')}`;
        const bar = m.querySelector('[data-progress]');
        const cur = m.querySelector('[data-current]');
        const tot = m.querySelector('[data-total]');
        const toggle = m.querySelector('[data-toggle]');
        const icoPause = m.querySelector('[data-icon-pause]');
        const icoPlay = m.querySelector('[data-icon-play]');
        const setPlayIcon = () => {
          const paused = v.paused;
          icoPause.style.display = paused ? 'none' : 'block'; icoPlay.style.display = paused ? 'block' : 'none';
          toggle.classList.toggle('is-paused', paused);
        };
        v.addEventListener('loadedmetadata', () => { tot.textContent = fmt(v.duration); });
        v.addEventListener('timeupdate', () => {
          cur.textContent = fmt(v.currentTime);
          if (v.duration) bar.style.width = `${(v.currentTime / v.duration) * 100}%`;
        });
        v.addEventListener('play', setPlayIcon);
        v.addEventListener('pause', setPlayIcon);
        toggle.addEventListener('click', () => (v.paused ? v.play() : v.pause()));
        v.addEventListener('click', () => (v.paused ? v.play() : v.pause()));
        m.querySelector('[data-mute]').addEventListener('click', () => {
          v.muted = !v.muted;
          m.querySelector('[data-icon-muted]').style.display = v.muted ? 'block' : 'none';
          m.querySelector('[data-icon-sound]').style.display = v.muted ? 'none' : 'block';
        });
        m.querySelector('[data-full]').addEventListener('click', () => {
          m.classList.toggle('dd-modal--expanded');
        });
      }

      const mains = [...m.querySelectorAll('[data-main-image]')];

      const thumbs = [...m.querySelectorAll('[data-thumb]')];
      thumbs.forEach((t) => {
        t.addEventListener('click', () => {
          if (t.dataset.full) mains.forEach((img) => { img.src = t.dataset.full; });
          thumbs.forEach((x) => x.classList.remove('is-active'));
          t.classList.add('is-active');
        });
      });

      const form = m.querySelector('[data-form]');
      const variantsEl = m.querySelector('[data-variants]');
      if (!form || !variantsEl) return;
      const variants = JSON.parse(variantsEl.textContent);
      const idInput = m.querySelector('[data-variant-input]');
      const addBtn = m.querySelector('[data-add]');
      const addLabel = m.querySelector('[data-add-label]');
      const priceEls = [...m.querySelectorAll('[data-price]')];
      const errorEl = m.querySelector('[data-error]');
      const combined = m.querySelector('[data-variant-select]');
      const pills = [...m.querySelectorAll('[data-opts] .dd-pill')];
      const optSelects = [...m.querySelectorAll('[data-opts] .dd-optselect')];
      const labelOk = addLabel.dataset.ok || addLabel.textContent.trim();
      addLabel.dataset.ok = labelOk;
      const soldOut = form.dataset.soldout || '';

      const money = (cents) => {
        let out = '';
        try {
          if (window.Shopify && Shopify.formatMoney) {
            out = Shopify.formatMoney(cents, (window.theme && theme.moneyFormat) || undefined) || '';
          }
        } catch (e) {}
        if (!out) {
          out = new Intl.NumberFormat('es-CO', {
            style: 'currency',
            currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'COP',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).format(cents / 100);
        }
        return out.replace(/([.,])00(?!\d)/, '');
      };

      const findVariant = (opts) => variants.find((vr) => vr.options.every((o, i) => o === opts[i]));

      let selected = [];

      const refreshUI = (variant) => {
        pills.forEach((pill) => {
          const pos = parseInt(pill.dataset.index, 10);
          const val = pill.dataset.value;
          pill.classList.toggle('is-active', selected[pos - 1] === val);
          const ok = variants.some((vr) => vr.available && vr.options[pos - 1] === val
            && selected.every((s, i) => (i === pos - 1) ? true : vr.options[i] === s));
          pill.classList.toggle('is-soldout', !ok);
        });
        optSelects.forEach((sel) => {
          const pos = parseInt(sel.dataset.index, 10);
          if (selected[pos - 1] != null) sel.value = selected[pos - 1];
        });
        if (combined && variant) combined.value = String(variant.id);
      };

      const applyVariant = (variant) => {
        errorEl.hidden = true;
        if (!variant) {
          addBtn.disabled = true;
          addLabel.textContent = soldOut;
          refreshUI(null);
          return;
        }
        selected = variant.options.slice();
        if (idInput) idInput.value = variant.id;
        priceEls.forEach((el) => { el.textContent = money(variant.price); });
        addBtn.disabled = !variant.available;
        addLabel.textContent = variant.available ? labelOk : soldOut;
        if (variant.featured_image) mains.forEach((img) => { img.src = variant.featured_image.src; });
        refreshUI(variant);
      };

      const pickByOption = (pos, val) => {
        const opts = selected.slice();
        opts[pos - 1] = val;
        let variant = findVariant(opts);
        if (!variant) variant = variants.find((vr) => vr.options[pos - 1] === val) || null;
        applyVariant(variant);
      };

      pills.forEach((pill) => pill.addEventListener('click', () => {
        pickByOption(parseInt(pill.dataset.index, 10), pill.dataset.value);
      }));
      optSelects.forEach((sel) => sel.addEventListener('change', () => {
        pickByOption(parseInt(sel.dataset.index, 10), sel.value);
      }));
      combined?.addEventListener('change', () => {
        const variant = variants.find((vr) => String(vr.id) === combined.value);
        if (variant) applyVariant(variant);
      });

      const initId = idInput ? String(idInput.value) : '';
      const initVariant = variants.find((vr) => String(vr.id) === initId) || variants[0];
      if (initVariant) applyVariant(initVariant);

      form.addEventListener('submit', (e) => {
        e.preventDefault();
        if (addBtn.disabled) return;
        addBtn.classList.add('is-loading');
        errorEl.hidden = true;
        this.addToCart(new FormData(form), true)
          .catch((err) => { errorEl.textContent = err.message || form.dataset.error || ''; errorEl.hidden = false; })
          .finally(() => addBtn.classList.remove('is-loading'));
      });
    }

    async addToCart(formData, closeAfter) {
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cart && cart.getSectionsToRender) {
        formData.append('sections', cart.getSectionsToRender().map((s) => s.id));
        formData.append('sections_url', window.location.pathname);
      }
      const url = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
      const res = await fetch(`${url}.js`, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      const data = await res.json();
      if (data.status || data.errors) throw new Error(data.description || data.message || this.dataset.error || '');
      if (closeAfter) this.closeModal();
      if (cart && cart.renderContents) cart.renderContents(data);
      else window.location.href = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    if (window.PersoUrbanHeader) return;

    const instances = new Map();
    const scrollLocks = new Set();
    window.PersoUrbanHeader = { instances };

    const cartRoot = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    const paintCart = (count) => {
      const link = document.getElementById('cart-icon-bubble');
      if (!link || typeof count !== 'number') return;
      let bubble = link.querySelector('.cart-count-bubble');
      if (count < 1) {
        if (bubble) bubble.remove();
        return;
      }
      if (!bubble) {
        bubble = document.createElement('span');
        bubble.className = 'cart-count-bubble';
        link.appendChild(bubble);
      }
      const shown = count < 100 ? String(count) : '';
      const first = bubble.firstElementChild;
      if (first && first.textContent === shown && bubble.childElementCount === 2) return;
      bubble.innerHTML = '<span aria-hidden="true">' + shown + '</span><span class="visually-hidden">' + count + '</span>';
    };

    const refreshCart = () =>
      fetch(cartRoot() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then((response) => response.json())
        .then((cart) => paintCart(cart.item_count))
        .catch(() => {});

    const hookCartEvents = () => {
      if (window.__puCartHooked) return;
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      window.__puCartHooked = true;
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCart);
    };

    if (!window.__puCartFetch) {
      window.__puCartFetch = true;
      const nativeFetch = window.fetch;
      window.fetch = function (input) {
        const request = nativeFetch.apply(this, arguments);
        try {
          const url = typeof input === 'string' ? input : (input && input.url) || '';
          if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
            request
              .then((response) => {
                if (!response || !response.ok) return;
                return response
                  .clone()
                  .json()
                  .then((data) => {
                    if (data && typeof data.item_count === 'number') paintCart(data.item_count);
                    else refreshCart();
                  });
              })
              .catch(() => {});
          }
        } catch (error) {}
        return request;
      };
    }

    hookCartEvents();
    document.addEventListener('DOMContentLoaded', hookCartEvents);
    window.addEventListener('load', hookCartEvents);
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) refreshCart();
    });

    const lockScroll = (key) => {
      scrollLocks.add(key);
      document.body.style.overflow = 'hidden';
    };

    const unlockScroll = (key) => {
      scrollLocks.delete(key);
      if (!scrollLocks.size) document.body.style.overflow = '';
    };

    const escapeHtml = (value) =>
      String(value == null ? '' : value).replace(/[&<>"']/g, (char) => {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
      });

    const withWidth = (url, width) => {
      if (!url) return '';
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    };

    if (!customElements.get('sticky-header')) {
      class StickyHeader extends HTMLElement {
        constructor() {
          super();
          this.setHeaderHeight = this.setHeaderHeight.bind(this);
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header');
          if (!this.header) return;
          this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
          this.headerIsAlwaysSticky =
            this.getAttribute('data-sticky-type') === 'always' ||
            this.getAttribute('data-sticky-type') === 'reduce-logo-size';
          this.headerBounds = {};

          this.setHeaderHeight();

          this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          }

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          if (!this.header) return;
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          if (!this.header) return;
          this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          const observer = new IntersectionObserver((entries, obs) => {
            this.headerBounds = entries[0].intersectionRect;
            obs.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (this.querySelector('.persourban-search-wrapper.is-active')) return;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (this.preventHide) return;
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
          if (this.headerIsAlwaysSticky) return;
          this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
          this.closeMenuDisclosure();
          this.closeSearchModal();
        }

        reveal() {
          if (this.headerIsAlwaysSticky) return;
          this.header.classList.add('shopify-section-header-sticky', 'animate');
          this.header.classList.remove('shopify-section-header-hidden');
        }

        reset() {
          if (this.headerIsAlwaysSticky) return;
          this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu, details-disclosure');
          this.disclosures.forEach((disclosure) => disclosure.close && disclosure.close());
          this.header.querySelectorAll('.persourban-drop.is-open').forEach((drop) => {
            drop.classList.remove('is-open');
          });
        }

        closeSearchModal() {
          this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
          this.searchModals.forEach((searchModal) => searchModal.close(false));
        }
      }

      customElements.define('sticky-header', StickyHeader);
    }

    document.addEventListener(
      'open',
      (event) => {
        if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

        const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
        event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
      },
      true
    );

    function setupMenu(header, id, signal) {
      const toggle = header.querySelector('[data-mobile-menu-toggle]');
      const menu = header.querySelector('[data-mobile-menu]');
      const backdrop = header.querySelector('[data-mobile-menu-backdrop]');
      if (!toggle || !menu) return;

      const closeButton = menu.querySelector('[data-mobile-menu-close]');
      const lockKey = 'menu-' + id;

      if (backdrop) document.body.appendChild(backdrop);
      document.body.appendChild(menu);

      const isOpen = () => menu.classList.contains('is-open');

      const open = () => {
        menu.classList.add('is-open');
        if (backdrop) backdrop.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        lockScroll(lockKey);
        if (typeof trapFocus === 'function') trapFocus(menu, closeButton || menu);
        else if (closeButton) closeButton.focus();
      };

      const close = () => {
        if (!isOpen()) return;
        menu.classList.remove('is-open');
        if (backdrop) backdrop.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        unlockScroll(lockKey);
        if (typeof removeTrapFocus === 'function') removeTrapFocus(toggle);
        else toggle.focus();
      };

      toggle.addEventListener('click', () => (isOpen() ? close() : open()), { signal });

      menu.addEventListener(
        'click',
        (event) => {
          const accToggle = event.target.closest('[data-acc-toggle]');
          if (!accToggle) return;
          const item = accToggle.closest('[data-acc]');
          if (!item) return;
          const willOpen = !item.classList.contains('is-open');
          item.classList.toggle('is-open', willOpen);
          accToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        },
        { signal }
      );
      if (closeButton) closeButton.addEventListener('click', close, { signal });
      if (backdrop) backdrop.addEventListener('click', close, { signal });

      document.addEventListener(
        'keydown',
        (event) => {
          if (event.key === 'Escape' && isOpen()) close();
        },
        { signal }
      );

      const desktop = window.matchMedia('(min-width: 990px)');
      desktop.addEventListener('change', (event) => event.matches && close(), { signal });
    }

    function setupSearch(header, id, signal) {
      const wrapper = header.querySelector('[data-predictive-search]');
      if (!wrapper) return;

      const input = wrapper.querySelector('[data-predictive-search-input]');
      const resultsEl = wrapper.querySelector('[data-predictive-search-results]');
      const closeButton = wrapper.querySelector('[data-predictive-search-close]');
      const form = wrapper.querySelector('form');
      if (!input || !resultsEl || !form) return;

      const config = wrapper.dataset;
      const searchUrl = config.searchUrl || '/search';
      const limit = parseInt(config.limit, 10) || 4;
      const lockKey = 'search-' + id;
      const mobile = window.matchMedia('(max-width: 989px)');
      const secondImages = new Map();

      let placeholder = null;
      let timer = null;
      let controller = null;
      let lastTerm = '';
      let refocusing = false;
      let formatter = null;

      const parsePrice = (value) => {
        if (!value) return null;
        const number = parseFloat(String(value).replace(/[^0-9.]/g, ''));
        return isNaN(number) ? null : number;
      };

      const formatPrice = (value) => {
        const number = parsePrice(value);
        if (number === null) return escapeHtml(value);
        try {
          formatter =
            formatter ||
            new Intl.NumberFormat(config.locale || undefined, {
              style: 'currency',
              currency: config.currency || 'COP',
              minimumFractionDigits: 0,
              maximumFractionDigits: number % 1 === 0 ? 0 : 2,
            });
          return escapeHtml(formatter.format(number));
        } catch (error) {
          return escapeHtml(Math.round(number).toLocaleString());
        }
      };

      const activate = () => {
        wrapper.classList.add('is-active');
        if (closeButton) closeButton.hidden = false;
        if (mobile.matches) lockScroll(lockKey);
        onInput();
      };

      const close = () => {
        clearTimeout(timer);
        if (controller) controller.abort();
        resultsEl.hidden = true;
        wrapper.classList.remove('is-active');
        if (closeButton) closeButton.hidden = true;
        unlockScroll(lockKey);

        if (placeholder && placeholder.parentNode) {
          placeholder.parentNode.insertBefore(wrapper, placeholder);
          placeholder.parentNode.removeChild(placeholder);
          placeholder = null;
        }
      };

      const onFocus = () => {
        if (refocusing) return;
        if (mobile.matches && wrapper.parentNode !== document.body) {
          placeholder = document.createTextNode('');
          wrapper.parentNode.insertBefore(placeholder, wrapper);
          refocusing = true;
          document.body.appendChild(wrapper);
          input.focus({ preventScroll: true });
          refocusing = false;
        }
        activate();
      };

      function onInput() {
        const term = input.value.trim();
        clearTimeout(timer);

        if (term.length < 2) {
          resultsEl.hidden = true;
          lastTerm = '';
          return;
        }

        if (term === lastTerm && !resultsEl.hidden) return;

        timer = setTimeout(() => fetchResults(term), 300);
      }

      function fetchResults(term) {
        if (controller) controller.abort();
        controller = new AbortController();
        lastTerm = term;

        const url =
          '/search/suggest.json?q=' +
          encodeURIComponent(term) +
          '&resources[type]=product&resources[limit]=' +
          limit +
          '&resources[options][unavailable_products]=last';

        fetch(url, { signal: controller.signal })
          .then((response) => response.json())
          .then((data) => renderResults(data, term))
          .catch((error) => {
            if (error.name !== 'AbortError') close();
          });
      }

      function renderResults(data, term) {
        const products =
          (data && data.resources && data.resources.results && data.resources.results.products) || [];

        if (!products.length) {
          resultsEl.innerHTML =
            '<p class="persourban-search__empty">' +
            escapeHtml((config.empty || '').replace('{term}', term)) +
            '</p>';
          resultsEl.hidden = false;
          return;
        }

        const cards = products
          .map((product) => {
            const image = product.featured_image ? product.featured_image.url : product.image;
            const price = parsePrice(product.price);
            const compare = parsePrice(product.compare_at_price);
            const onSale = compare && price && compare > price;
            const imageSrc = withWidth(image, 400);

            return (
              '<a href="' + escapeHtml(product.url) + '" class="persourban-search__result" data-handle="' + escapeHtml(product.handle || '') + '">' +
              '<span class="persourban-search__result-media">' +
              (imageSrc
                ? '<img src="' + escapeHtml(imageSrc) + '" alt="" class="persourban-search__result-img persourban-search__result-img--primary" width="400" height="533" loading="lazy">'
                : '') +
              '<img alt="" class="persourban-search__result-img persourban-search__result-img--secondary" width="400" height="533" loading="lazy">' +
              '</span>' +
              '<span class="persourban-search__result-title">' + escapeHtml(product.title) + '</span>' +
              '<span class="persourban-search__result-prices">' +
              '<span class="persourban-search__result-price">' + formatPrice(product.price) + '</span>' +
              (onSale ? '<s class="persourban-search__result-compare">' + formatPrice(product.compare_at_price) + '</s>' : '') +
              '</span>' +
              '</a>'
            );
          })
          .join('');

        resultsEl.innerHTML =
          '<div class="persourban-search__results-grid">' + cards + '</div>' +
          '<a href="' + escapeHtml(searchUrl) + '?q=' + encodeURIComponent(term) + '" class="persourban-search__view-all">' +
          escapeHtml(config.viewAll || '') +
          '</a>';
        resultsEl.hidden = false;

        resultsEl.querySelectorAll('.persourban-search__result').forEach((card) => {
          const load = () => loadSecondImage(card);
          card.addEventListener('mouseenter', load, { once: true });
          card.addEventListener('focusin', load, { once: true });
        });
      }

      function loadSecondImage(card) {
        const handle = card.getAttribute('data-handle');
        const target = card.querySelector('.persourban-search__result-img--secondary');
        if (!handle || !target) return;

        if (secondImages.has(handle)) {
          const cached = secondImages.get(handle);
          if (cached) target.src = cached;
          return;
        }

        fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then((response) => response.json())
          .then((product) => {
            const second = product.images && product.images.length > 1 ? withWidth(product.images[1], 400) : '';
            secondImages.set(handle, second);
            if (second) target.src = second;
          })
          .catch(() => {});
      }

      input.addEventListener('focus', onFocus, { signal });
      input.addEventListener('input', onInput, { signal });

      input.addEventListener(
        'keydown',
        (event) => {
          if (event.key === 'ArrowDown') {
            const first = resultsEl.querySelector('a');
            if (first && !resultsEl.hidden) {
              event.preventDefault();
              first.focus();
            }
          }
        },
        { signal }
      );

      resultsEl.addEventListener(
        'keydown',
        (event) => {
          if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
          const links = Array.from(resultsEl.querySelectorAll('a'));
          const index = links.indexOf(document.activeElement);
          if (index === -1) return;
          event.preventDefault();
          if (event.key === 'ArrowUp' && index === 0) {
            input.focus();
          } else {
            const next = links[index + (event.key === 'ArrowDown' ? 1 : -1)];
            if (next) next.focus();
          }
        },
        { signal }
      );

      wrapper.addEventListener(
        'keydown',
        (event) => {
          if (event.key === 'Escape') {
            close();
            input.blur();
          }
        },
        { signal }
      );

      wrapper.addEventListener(
        'focusout',
        (event) => {
          if (event.relatedTarget && !wrapper.contains(event.relatedTarget)) close();
        },
        { signal }
      );

      document.addEventListener(
        'click',
        (event) => {
          if (!wrapper.contains(event.target)) close();
        },
        { signal }
      );

      if (closeButton) {
        closeButton.addEventListener(
          'click',
          () => {
            close();
            input.blur();
          },
          { signal }
        );
      }

      mobile.addEventListener('change', close, { signal });
    }

    function setDropOpen(drop, open) {
      drop.classList.toggle('is-open', open);
      drop.querySelectorAll(':scope > [data-drop-toggle]').forEach((toggle) => {
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    function setupDrops(header, signal) {
      const drops = () => header.querySelectorAll('[data-drop]');
      const timers = new WeakMap();

      const cancelClose = (drop) => clearTimeout(timers.get(drop));

      const closeOthers = (current) => {
        drops().forEach((other) => {
          if (other === current) return;
          cancelClose(other);
          setDropOpen(other, false);
        });
      };

      drops().forEach((drop) => {
        drop.addEventListener(
          'pointerenter',
          (event) => {
            if (event.pointerType !== 'mouse') return;
            cancelClose(drop);
            if (drop.dataset.puSuppress === '1') return;
            closeOthers(drop);
            setDropOpen(drop, true);
          },
          { signal }
        );

        drop.addEventListener(
          'pointerleave',
          (event) => {
            if (event.pointerType !== 'mouse') return;
            delete drop.dataset.puSuppress;
            cancelClose(drop);
            timers.set(
              drop,
              setTimeout(() => setDropOpen(drop, false), 120)
            );
          },
          { signal }
        );
      });

      header.addEventListener(
        'click',
        (event) => {
          const toggle = event.target.closest('[data-drop-toggle]');
          if (!toggle) return;
          const drop = toggle.closest('[data-drop]');
          if (!drop) return;
          cancelClose(drop);
          const willOpen = !drop.classList.contains('is-open');
          closeOthers(drop);
          setDropOpen(drop, willOpen);
          if (willOpen || !drop.matches(':hover')) delete drop.dataset.puSuppress;
          else drop.dataset.puSuppress = '1';
        },
        { signal }
      );

      document.addEventListener(
        'click',
        (event) => {
          drops().forEach((drop) => {
            if (!drop.contains(event.target)) setDropOpen(drop, false);
          });
        },
        { signal }
      );

      document.addEventListener(
        'keydown',
        (event) => {
          if (event.key !== 'Escape') return;
          drops().forEach((drop) => {
            if (!drop.classList.contains('is-open')) return;
            setDropOpen(drop, false);
            if (drop.matches(':hover')) drop.dataset.puSuppress = '1';
            const toggle = drop.querySelector(':scope > [data-drop-toggle]');
            if (toggle) toggle.focus();
          });
        },
        { signal }
      );
    }

    function setupGlass(header, signal) {
      if (!header.hasAttribute('data-glass')) return;
      const wrapper = header.closest('.header-wrapper');
      if (!wrapper) return;

      let ticking = false;
      const update = () => {
        ticking = false;
        const y = window.pageYOffset || document.documentElement.scrollTop;
        wrapper.classList.toggle('persourban-is-scrolled', y > 8);
      };

      window.addEventListener(
        'scroll',
        () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(update);
        },
        { passive: true, signal }
      );

      update();
    }

    function destroy(id) {
      const instance = instances.get(id);
      if (instance) {
        instance.controller.abort();
        instances.delete(id);
      }
      document.body.querySelectorAll(':scope > [data-pu-hd="' + id + '"]').forEach((node) => node.remove());
      unlockScroll('menu-' + id);
      unlockScroll('search-' + id);
    }

    function init(header) {
      const id = header.getAttribute('data-pu-hd');
      if (!id) return;
      const existing = instances.get(id);
      if (existing && existing.header === header) return;
      destroy(id);

      const controller = new AbortController();
      const { signal } = controller;

      setupMenu(header, id, signal);
      setupSearch(header, id, signal);
      setupDrops(header, signal);
      setupGlass(header, signal);

      instances.set(id, { controller, header });
    }

    const boot = () => document.querySelectorAll('header[data-pu-hd]').forEach(init);

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
    else boot();

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('header[data-pu-hd]').forEach(init);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('header[data-pu-hd]').forEach((header) => {
        destroy(header.getAttribute('data-pu-hd'));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pu-related')) {
  customElements.define('pu-related', class PuRelated extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.cards = [...this.track.querySelectorAll('[data-card]')];
      this.fill = this.querySelector('[data-progress]');
      this.count = this.querySelector('[data-count]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.nav = this.querySelector('[data-nav]');
      this.sheets = [...this.querySelectorAll('.pu-rel-sheet')];
      this.sheets.forEach((s) => { document.body.appendChild(s); this.setupSheet(s); });
      this.cards.forEach((c) => {
        const img = c.querySelector('.pu-rel__media img');
        if (!img) return;
        img.addEventListener('error', () => {
          if (img.dataset.retry) return;
          img.dataset.retry = '1';
          const src = img.getAttribute('src');
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.loading = 'eager';
          img.src = src;
        });
        if (img.complete && img.naturalWidth === 0 && img.getAttribute('src')) {
          const src = img.getAttribute('src');
          img.removeAttribute('srcset');
          img.src = src;
        }
      });
      this.key = '';
      this.layout();
      this.update();

      this.onResize = () => {
        cancelAnimationFrame(this.rz);
        this.rz = requestAnimationFrame(() => { this.layout(); this.update(); });
      };
      window.addEventListener('resize', this.onResize);
      this.onScroll = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => { this.raf = 0; this.update(); });
      };
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(-1); }
      });
      this.addEventListener('click', (e) => this.onClick(e));

      this.escHandler = (e) => { if (e.key === 'Escape') this.closeSheet(); };
      document.addEventListener('keydown', this.escHandler);

      const show = () => this.track.classList.add('is-in');
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          if (entries.some((en) => en.isIntersecting)) { show(); this.io.disconnect(); }
        }, { threshold: 0.1 });
        this.io.observe(this.track);
        setTimeout(show, 1200);
      } else {
        show();
      }
    }

    disconnectedCallback() {
      this.sheets.forEach((s) => s.remove());
      if (this.io) this.io.disconnect();
      document.removeEventListener('keydown', this.escHandler);
      window.removeEventListener('resize', this.onResize);
      document.body.classList.remove('pu-rel-lock');
    }

    layout() {
      const cs = getComputedStyle(this);
      const cols = parseInt(cs.getPropertyValue('--pu-cols'), 10) || 2;
      const rows = parseInt(cs.getPropertyValue('--pu-rows'), 10) || 1;
      const key = cols + 'x' + rows;
      if (key === this.key) return;
      this.key = key;
      const per = cols * rows;
      this.track.textContent = '';
      for (let i = 0; i < this.cards.length; i += per) {
        const page = document.createElement('div');
        page.className = 'pu-rel__page';
        this.cards.slice(i, i + per).forEach((c) => page.appendChild(c));
        this.track.appendChild(page);
      }
      this.track.classList.add('is-paged');
      this.track.scrollLeft = 0;
    }

    pageCount() { return this.track.children.length; }

    update() {
      const n = this.pageCount();
      const w = this.track.clientWidth || 1;
      const max = Math.max(0, (n - 1) * w);
      const left = Math.min(Math.max(this.track.scrollLeft, 0), max);
      const cur = Math.min(n - 1, Math.max(0, Math.round(left / w)));
      if (this.fill) {
        this.fill.style.width = (100 / n) + '%';
        this.fill.style.transform = 'translateX(' + ((left / w) * 100) + '%)';
      }
      if (this.count) this.count.textContent = String(cur + 1).padStart(2, '0') + ' / ' + String(n).padStart(2, '0');
      if (this.nav) this.nav.hidden = n <= 1;
      if (this.prev) this.prev.disabled = left <= 2;
      if (this.next) this.next.disabled = left >= max - 2;
    }

    go(dir) {
      const n = this.pageCount();
      const w = this.track.clientWidth || 1;
      const cur = Math.round(this.track.scrollLeft / w);
      const to = Math.min(n - 1, Math.max(0, cur + dir));
      this.track.scrollTo({ left: to * w, behavior: 'smooth' });
    }

    flash(btn, text) {
      const label = btn.querySelector('[data-label]');
      if (!label || !text) return;
      if (!btn.dataset.label) btn.dataset.label = label.textContent;
      label.textContent = text;
      clearTimeout(btn.flashTimer);
      btn.flashTimer = setTimeout(() => { label.textContent = btn.dataset.label; }, 1600);
    }

    onClick(e) {
      if (e.target.closest('[data-prev]')) { this.go(-1); return; }
      if (e.target.closest('[data-next]')) { this.go(1); return; }
      const add = e.target.closest('[data-add]');
      if (!add || add.disabled) return;
      if (add.dataset.single === 'true') {
        const fd = new FormData();
        fd.append('id', add.dataset.variantId);
        fd.append('quantity', 1);
        add.classList.add('is-loading');
        this.addToCart(fd)
          .then(() => this.flash(add, this.dataset.added))
          .catch(() => this.flash(add, this.dataset.error))
          .finally(() => add.classList.remove('is-loading'));
      } else {
        this.openSheet(add.dataset.sheet);
      }
    }

    openSheet(id) {
      const s = this.sheets.find((x) => x.dataset.sheet === id);
      if (!s) return;
      this.closeSheet();
      s.hidden = false;
      document.body.classList.add('pu-rel-lock');
      this.active = s;
      const x = s.querySelector('.pu-rel-sheet__x');
      if (x) x.focus();
    }

    closeSheet() {
      if (!this.active) return;
      this.active.hidden = true;
      document.body.classList.remove('pu-rel-lock');
      this.active = null;
    }

    setupSheet(s) {
      s.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', () => this.closeSheet()));
      const variantsEl = s.querySelector('[data-variants]');
      if (!variantsEl) return;
      const variants = JSON.parse(variantsEl.textContent);
      const idInput = s.querySelector('[data-variant-input]');
      const addBtn = s.querySelector('[data-add-sheet]');
      const buyBtn = s.querySelector('[data-buy-sheet]');
      const addLabel = s.querySelector('[data-add-label]');
      const priceEl = s.querySelector('[data-price]');
      const errorEl = s.querySelector('[data-error]');
      const mains = [...s.querySelectorAll('[data-main-image]')];
      const pills = [...s.querySelectorAll('[data-opt-value]')];
      const labelOk = addBtn.dataset.ok;
      const soldOut = this.dataset.soldout || '';
      let selected = [];

      const money = (cents) => {
        let out = '';
        try {
          if (window.Shopify && Shopify.formatMoney) {
            out = Shopify.formatMoney(cents, (window.theme && theme.moneyFormat) || undefined) || '';
          }
        } catch (e) {}
        if (!out) {
          out = new Intl.NumberFormat('es-CO', {
            style: 'currency',
            currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'COP',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).format(cents / 100);
        }
        return out.replace(/([.,])00(?!\d)/, '');
      };

      const refresh = () => {
        pills.forEach((pill) => {
          const pos = parseInt(pill.dataset.index, 10);
          const val = pill.dataset.value;
          pill.classList.toggle('is-active', selected[pos - 1] === val);
          const ok = variants.some((vr) => vr.available && vr.options[pos - 1] === val
            && selected.every((o, i) => (i === pos - 1) ? true : vr.options[i] === o));
          pill.classList.toggle('is-soldout', !ok);
        });
      };

      const apply = (variant) => {
        errorEl.hidden = true;
        if (!variant) {
          addBtn.disabled = true;
          if (buyBtn) buyBtn.disabled = true;
          addLabel.textContent = soldOut;
          refresh();
          return;
        }
        selected = variant.options.slice();
        idInput.value = variant.id;
        priceEl.textContent = money(variant.price);
        addBtn.disabled = !variant.available;
        if (buyBtn) buyBtn.disabled = !variant.available;
        addLabel.textContent = variant.available ? labelOk : soldOut;
        if (variant.featured_image && variant.featured_image.src) mains.forEach((img) => { img.src = variant.featured_image.src; });
        refresh();
      };

      pills.forEach((pill) => pill.addEventListener('click', () => {
        const pos = parseInt(pill.dataset.index, 10);
        const opts = selected.slice();
        opts[pos - 1] = pill.dataset.value;
        let variant = variants.find((vr) => vr.options.every((o, i) => o === opts[i]));
        if (!variant) variant = variants.find((vr) => vr.options[pos - 1] === pill.dataset.value) || null;
        apply(variant);
      }));

      const initial = variants.find((vr) => String(vr.id) === String(idInput.value)) || variants[0];
      if (initial) apply(initial);

      const submit = (btn, buy) => {
        if (btn.disabled) return;
        const fd = new FormData();
        fd.append('id', idInput.value);
        fd.append('quantity', 1);
        btn.classList.add('is-loading');
        errorEl.hidden = true;
        this.addToCart(fd, { buy, close: true })
          .catch((err) => { errorEl.textContent = err.message || this.dataset.error || ''; errorEl.hidden = false; })
          .finally(() => btn.classList.remove('is-loading'));
      };
      addBtn.addEventListener('click', () => submit(addBtn, false));
      if (buyBtn) buyBtn.addEventListener('click', () => submit(buyBtn, true));
    }

    async addToCart(formData, opts) {
      const o = opts || {};
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (!o.buy && cart && cart.getSectionsToRender) {
        formData.append('sections', cart.getSectionsToRender().map((s) => s.id));
        formData.append('sections_url', window.location.pathname);
      }
      const url = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
      const res = await fetch(`${url}.js`, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      const data = await res.json();
      if (data.status || data.errors) throw new Error(data.description || data.message || this.dataset.error || '');
      if (o.buy) { window.location.href = '/checkout'; return data; }
      if (o.close) this.closeSheet();
      if (cart && cart.renderContents) cart.renderContents(data);
      else window.location.href = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
      return data;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
